import { render, staticRenderFns } from "./NewOtpDelivery.vue?vue&type=template&id=657a72a6&scoped=true"
import script from "./NewOtpDelivery.vue?vue&type=script&lang=js"
export * from "./NewOtpDelivery.vue?vue&type=script&lang=js"
import style0 from "./NewOtpDelivery.vue?vue&type=style&index=0&id=657a72a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a72a6",
  null
  
)

export default component.exports